<template>
  <div>
    <Alert v-bind="alertprops"/>
    <v-data-table
      :headers="headers"
      :items="categoryData"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Category</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="green"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                New Category
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      
                    >
                      <v-text-field
                        v-model="editedItem.category"
                        label="Category name"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.category="{ value }">
        <router-link :to="`/en/admin/properties/${value.toLowerCase()}`">
            {{ value }}
        </router-link>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          medium
          class="mr-2"
          color="blue"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          medium
          color="red"
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Alert from '../../components/Alert'
  import PropertyCategoryService from '../../services/PropertyCategoryService'

  export default {
    name: "Company",
    components: {
      Alert
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Category name',
          align: 'start',
          sortable: true,
          value: 'category',
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      categoryData: [],
      editedIndex: -1,
      editedItem: {
        category: '',
      },
      defaultItem: {
        category: '',
      },
      alertprops: {
        alertType: '',
        content: '',
        alert: false
      }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Category' : 'Edit Category'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    updated() {
      setTimeout(()=>{
        this.alertprops.alert = false
      },2000)
    },

    methods: {
      ...mapActions(['logout']),
      
      initialize () {
        PropertyCategoryService.read()
        .then(category => {
          this.categoryData = category.data
        })
        .catch(err => {
            this.getAlertData("error", err.response.data.message, true)
        })
      },

      editItem (item) {
        this.editedIndex = this.categoryData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.categoryData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        PropertyCategoryService.delete(this.categoryData[this.editedIndex].category)
        .then(res => {
          this.getAlertData("success", res.data.message, true)
          this.initialize()
          this.closeDelete()
        })
        .catch(err => {
          this.getAlertData("error", err.response.data.message, true)
          this.checkAuth(err)
        })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          const updatedData = {
            category: this.editedItem.category
          }
          PropertyCategoryService.update(this.categoryData[this.editedIndex]._id, updatedData)
          .then(res => {
            this.getAlertData("success", res.data.message, true)
            this.initialize()
          })
          .catch(err => {
            this.getAlertData("error", err.response.data.message, true)
            this.checkAuth(err)
          })
        } else {
          const data = {
            category: this.editedItem.category
          }
          PropertyCategoryService.create(data)
          .then(res => {
            this.getAlertData("success", res.data.message, true)
            this.initialize()
          })
          .catch(err => {
            this.getAlertData("error", err.response.data.message, true)
            this.checkAuth(err)
          })
        }
        this.close()
      },

      getAlertData(type, content, alert) {
        this.alertprops.alertType = type,
        this.alertprops.content = content,
        this.alertprops.alert = alert
      },

      checkAuth(err){
        if(err.response.status == 403){
          setTimeout(()=>{
            this.logout()
          },2000)
        }
      }
    },
  }
</script>